import { FC } from "react";
import { DatePicker } from "antd";
import MyCareLogo from "@assets/images/myCareLogo.png";
import Icon from "../../../assets/icon_config";
import "./header.scss";

interface HeaderProps {
  refreshDate : any;
  setRefreshDate : (x: any) => void;
  setDropdownValueChanged : (x: any) => void;
  setInitialBuild : (x: any) => void;
}
const Header: FC<HeaderProps> = ({ refreshDate , setRefreshDate , setDropdownValueChanged , setInitialBuild}) => {
  return (
    <div className="header-container">
      <div className="header-container__logo-tittle-container">
        <div>
          <img src={MyCareLogo} alt="dashboardReport" className="header-container__logo-tittle-container--logo" />
        </div>
        <div className="header-container__logo-tittle-container--tittle">
          <span className="header-container__logo-tittle-container--tittle--style">High Cost Patient Report</span>
        </div>
      </div>

      <div>
        <DatePicker
          format={"MMMM YYYY"}
          size="large"
          picker="month"
          value={refreshDate}
          suffixIcon={<Icon name="calender" />}
          onChange={(value) => {
            setRefreshDate(value);
            //to change the caluclate rank button disabled state
            setDropdownValueChanged(true);
            setInitialBuild(false);
          }}
          allowClear={false}
        />
      </div>
    </div>
  );
};

export default Header;
